import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "store/baseUrls";
import { xApiKey } from "store/apiKeys";
import type { RootState } from "..";
import type { Result } from "store/api.type";
import type { Track } from "./track.model";

export const trackApi = createApi({
  reducerPath: "trackApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Accept", "application/json");
      headers.set("X-Api-Key", xApiKey);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getTracks: builder.query<Track[], void>({
      query: () => "/v1/Track",
      transformResponse: (data: Result<Track>) => data.list,
    }),
    getLatestForeignTracks: builder.query<
      Track[],
      { offset?: number; limit?: number }
    >({
      query: ({ offset = 0, limit = 20 }) =>
        `/v1/Track?select=&isPersianSong=false&maxSize=${limit}&offset=${offset}`,
      transformResponse: (data: Result<Track>) => data.list,
    }),
    getLatestIranianTracks: builder.query<
      Track[],
      { offset?: number; limit?: number }
    >({
      query: ({ offset = 0, limit = 20 }) =>
        `/v1/Track?select=&isPersianSong=true&maxSize=${limit}&offset=${offset}`,
      transformResponse: (data: Result<Track>) => data.list,
    }),
    getTrack: builder.query<Track, { trackId: string }>({
      query: ({ trackId }) => `/v1/Track/${trackId}`,
    }),
    getLyric: builder.query<string, { lyricUrl: string }>({
      query: ({ lyricUrl }) => ({
        url: lyricUrl,
        responseHandler: "text",
      }),
    }),
  }),
});

export const {
  useGetTracksQuery,
  useGetTrackQuery,
  useGetLatestForeignTracksQuery,
  useGetLatestIranianTracksQuery,
  useGetLyricQuery,
  util: trackApiUtil,
} = trackApi;
